<template>
  <main class="input" v-show="show">
    <!-- Title -->
    <p>COUNTDOWN TIMER</p>

    <!-- Display -->
    <section class="display">
      <span class="time">
        <h3>{{ hours }}</h3>
        <p>h</p>
      </span>
      <span class="time">
        <h3>{{ minutes }}</h3>
        <p>m</p>
      </span>
      <span class="time">
        <h3>{{ seconds }}</h3>
        <p>s</p>
      </span>
    </section>

    <!-- Keypad -->
    <section class="keypad">
      <button
        v-for="button in buttons"
        v-bind:key="button.key"
        v-on:click="updateTime(button.value)"
        v-bind:disabled="disableKey(button.value)"
      >
        {{ button.key }}
      </button>
    </section>
  </main>
</template>

<script>
import { BUTTONS } from "../state/buttons.ts";

export default {
  name: "RbGoogTimeInput",
  props: {
    show: Boolean,
  },
  data() {
    const buttons = BUTTONS;
    const hours = "--";
    const minutes = "--";
    const seconds = "--";
    const time = [];
    return {
      buttons,
      hours,
      minutes,
      seconds,
      time,
    };
  },
  watch: {
    time(inValue) {
      const allZeros = inValue.every((value) => value === 0);
      this.$emit("allTimeDigitsZero", allZeros);

      if (allZeros && inValue.length >= 6) {
        if (navigator && typeof navigator.vibrate === "function") {
          navigator.vibrate([300, 10, 300, 10]);
        }
      }

      if (inValue.length >= 0) {
        const [hours, minutes, seconds] = inValue
          .map(String)
          .join("")
          .padStart(6, "-")
          .split(/(..)/g)
          .filter((s) => s);
        this.hours = hours;
        this.minutes = minutes;
        this.seconds = seconds;
        this.$emit("timeUpdated", this.hours, this.minutes, this.seconds);
      }
    },
    show(inNewValue) {
      if (inNewValue === true) {
        this.reset();
      }
    },
  },
  methods: {
    isX(inButtonValue) {
      return inButtonValue === -1 ? true : false;
    },
    isDoubleZero(inButtonValue) {
      return inButtonValue === 10 ? true : false;
    },
    disableKey(inButtonValue) {
      if (this.isX(inButtonValue) && this.time.length === 0) {
        return true;
      } else {
        if (this.time.length === 6) {
          return !this.isX(inButtonValue);
        } else if (this.time.length === 5) {
          return this.isDoubleZero(inButtonValue);
        }
      }
      return false;
    },
    updateTime(inButtonValue) {
      const buttonValues = this.buttons.map((button) => button.value);
      if (!buttonValues.includes(inButtonValue)) {
        return;
      }
      if (inButtonValue === -1) {
        if (this.time.length > 0) {
          if (navigator && typeof navigator.vibrate === "function") {
            navigator.vibrate([100]);
          }
          this.time.pop();
        }
      } else {
        if (this.time.length >= 6) {
          return;
        }
        if (navigator && typeof navigator.vibrate === "function") {
          navigator.vibrate([10]);
        }
        if (inButtonValue === 10) {
          this.time.push(0);
          this.time.push(0);
        } else {
          this.time.push(inButtonValue);
        }
        if (this.time.length > 0) {
          this.$emit("timeAdded");
        }
      }
    },
    reset() {
      this.time = [];
      this.hours = "--";
      this.minutes = "--";
      this.seconds = "--";
    },
  },
};
</script>

<style lang="scss" scoped>
.input {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  .display {
    margin: 20px auto;
    display: flex;
    justify-content: center;
    gap: 30px;
    flex-wrap: wrap;
    color: var(--gray-9);

    .time {
      width: var(--size-fluid-7);
      height: var(--size-fluid-5);
      text-align: center;
      font-family: "Orbitron", sans-serif;
      font-size: 25px;
      font-weight: bold;
      border: none;

      background-color: var(--gray-0);
      border-radius: var(--radius-blob-3);
      box-shadow: var(--shadow-4);

      display: flex;
      justify-content: center;
      align-items: center;

      h3 {
        color: var(--gray-9);
      }

      p {
        color: var(--gray-7);
      }
    }
  }

  .keypad {
    margin: 20px auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1em;

    button {
      color: var(--blue-6);

      width: var(--size-fluid-5);
      height: var(--size-fluid-5);

      text-align: center;
      background-color: var(--blue-0);

      text-shadow: 0 1px 0 var(--blue-2);
      font-family: var(--font-mono);
      font-size: var(--font-size-fluid-1);
      font-weight: var(--font-weight-7);

      padding: var(--size-fluid-2);

      border-radius: var(--radius-blob-3);
      aspect-ratio: var(--ratio-square);
      border: 2px solid var(--gray-9);
      box-shadow: var(--shadow-2);

      &[disabled="disabled"] {
        color: var(--gray-6);
        background-color: var(--gray-4);
        cursor: not-allowed;
        border: 2px solid var(--gray-6);
      }

      &:hover:not([disabled="disabled"]) {
        background-color: var(--blue-1);
        box-shadow: var(--shadow-6);
        transform: scale(1.1);
        cursor: pointer;
        transition: all 0.1s linear;
      }
    }
  }
}
</style>
